<div class="comments-list">
    <div class="comment"  *ngFor="let key of commentsListKeys">
        <app-comment-each (replyClick)="onReplyClick($event)" [commentData]="commentsList[key]"></app-comment-each>
        <!-- {{commentsList[key] | json}} -->
    </div>
</div>
